import {PlayersList as NFLClassicPlayersList} from './nfl/classic';
import {PlayersList as NFLSingleGamePlayersList} from 'components/organisms/used-players-list/components/desktop/players-list/sports/nfl/single-game';
import Const from 'constants';

const classesMap = {
    [Const.LEAGUE_NFL]: {
        [Const.GAME_TYPE_CLASSIC]: NFLClassicPlayersList,
        [Const.GAME_TYPE_SINGLEGAME]: NFLSingleGamePlayersList,
    },
};

const Factory = {
    getComponent(sportConfig) {
        const sportName = sportConfig.getSport().toLowerCase();
        const gameType = sportConfig.getGameType().toLowerCase();

        const componentClass = classesMap[sportName]?.[gameType] ?? null;

        if (componentClass === null) {
            throw new Error(`Unsupported factory for "${sportName}", "${gameType}".`);
        }

        return componentClass;
    },
};

export {Factory};
